import React from "react";
import { IAppTableColumnProps } from "./AppTableColumn";
import { Checkbox,Icon } from 'antd';
import {AppTableContext} from "./AppTable"
export interface IProps {
	columns: IAppTableColumnProps[];
	width?:number;
}


export class AppTableHeader extends React.Component<IProps> {

	state = {};

	renderColGroup = () => {
		let { columns } = this.props
		return (
			<colgroup>
				{columns.map((column: IAppTableColumnProps, index) => {
					return (column.width || column.width!==0) ? <col key={`${index}_col`} width={`${column.width}px`} /> : <col key={`${index}_col`} />
				})}
			</colgroup>
		);
	}

	rendersort = () => {
		return false;
		<Icon className="app-grid-header-td-sort" type="sort-ascending" />
	}

	renderTD = (context:AppTableContext,column:IAppTableColumnProps,key:string) =>{
		let indeterminate = context.allSelectStatus === 2;
		let checked = context.allSelectStatus === 3;
		let tdContent ;
		if(column.field === "__table_check_box"){
			tdContent = <div><Checkbox 
							  indeterminate={indeterminate} checked={checked}  
							  onChange={(e)=>{context.rowAllSelected(e.target.checked)}} 
							  />
							  </div>
		}else{
			tdContent = column.title || '';
		}
		return (<td key={key} className="app-grid-header-td"><div className="app-grid-header-td-outer">{tdContent}</div>
			{this.rendersort()}
		</td>)
	}


	renderHeader = (context:AppTableContext) =>{
		let { columns,width } = this.props;
		let currentwidth
		if(width===-1||width===undefined){
			currentwidth='100%';
		}else{
			currentwidth=width+'px';
		}
		return (
			<table cellPadding="0" cellSpacing="0" style={{ width: currentwidth }}>
				{this.renderColGroup()}
				<tbody>
					<tr className="app-grid-header-tr">
						{columns.map((column: IAppTableColumnProps, index) => {
							let key = `${index}_header_tr_td`;
							return this.renderTD(context,column,key);
						})}
					</tr>
				</tbody>
			</table>)
	} 

	render() {
		return (<AppTableContext.Consumer>{this.renderHeader}</AppTableContext.Consumer>);
	}
}


// WEBPACK FOOTER //
// ./src/components/AppTable/AppTableHeader.tsx